import { DossierDto } from '@scip/api/model/dossier-dto';
import { DossierType, RequestedType, SubmissionStatus } from '../models';
import { DossierSearchResultDto } from '@scip/api/model/dossier-search-result-dto';

export class DossierUtils {
  static getTranslationKey(state: string): string {
    return 'dossierDto.status.' + state;
  }

  static getTooltipTranslationKey(state: string): string {
    return 'dossierDto.tooltip.' + state;
  }

  static canDownload(dossier: DossierSearchResultDto | DossierDto): boolean {
    // As we are currently reworking the dossier handling, it could be that there is a dossier without a state
    // if there is no state, do not show the download link as we are not sure if its downloadable
    if (!dossier) {
      return false;
    }

    // Other submissions than FULL are reusing the dossier file from the FULL Submission
    if (dossier.type !== 'FULL') {
      return false;
    }

    // A parts only submission only have dossierfiles for the children, not for the parent
    // The parent is not having a parentPartsProduct/ parentPartsProductName, it can either be undefined or an empty object,
    // so check for the same attribute we use in the table
    if (dossier.requestedType === 'PARTS_ONLY') {
      // We have two different interfaces, but both in common is, if they do not have both properties, they
      // are a parent-parts-only submission ;) When they have at least one, no matter which interface,
      // they are a child submission and have a dossier
      if (!(dossier as any).parentPartsProductName && !(dossier as any).parentPartsProduct) {
        return false;
      }
    }

    const allowedStates: string[] = [
      SubmissionStatus.DOSSIER_FILE_CREATED,
      SubmissionStatus.DOSSIER_SENT_TO_ECHA,
      SubmissionStatus.PENDING,
      SubmissionStatus.SUBMITTED,
      SubmissionStatus.VALIDATION_SUCCEEDED,
      SubmissionStatus.FAILED,
      SubmissionStatus.VALIDATION_FAILED
    ];
    return allowedStates.includes(dossier.status);
  }

  static canOpenECHAPortal(dossier: DossierSearchResultDto | DossierDto): boolean {
    return !!dossier?.reportUrl?.trim().length;
  }
}
